<!--报文阻塞监控-->
<template>
    <div>
        <Panel title="报文阻塞查询">
            <template slot="buttons">
                <el-button title="查询" class="blue" @click="pageTable.handleLoad()" icon="el-icon-fa-search">查询</el-button>
                <el-button title="重置" class="yellow" @click="pageTable.handleReset()" icon="el-icon-fa-undo">重置</el-button>

            </template>
            <el-form :model="pageTable.param" ref="queryForm">
                <el-row>
                    <el-col :lg='4' :sm='12'>
                        <el-form-item label="线程名称">
                            <el-input v-model="pageTable.param.td_name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg='8' :sm='12'>
                        <el-form-item class="flex-2" label="异常时间">
                            <el-date-picker v-model="pageTable.param.range_time" type="datetimerange" placeholder="选择日期范围"
                                            :picker-options="UsualConfig.pickerOptionsQuickSelect"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </Panel>
        <Panel title="报文阻塞列表">
            <template slot="buttons">
                <el-button title="中断选择的阻塞异常" class="blue" @click="interruptBlock" icon="el-icon-fa-trash">中断阻塞</el-button>
                <el-button title="删除选定" class="red" @click="doSeleDel" icon="el-icon-fa-trash">删除选定</el-button>
                <el-button title="删除全部" class="red" @click="doAllDel" icon="el-icon-fa-trash">删除全部</el-button>
            </template>
            <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                      ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                      element-loading-text="数据加载中" :height="tableHeight" @sort-change="handleSorted">
                <el-table-column prop="$rownum" label="NO." width="70" align="center"/>
                <el-table-column type="selection" align='center' width="50"></el-table-column>
                <!--<el-table-column prop="host" label="主机标识" sortable='custom' min-width='100px'></el-table-column>-->
                <el-table-column prop="tdname" label="线程名称" sortable='custom' show-overflow-tooltip></el-table-column>
                <el-table-column prop="pedesc" label="异常信息" sortable='custom' show-overflow-tooltip></el-table-column>
                <el-table-column prop="pecode" label="异常代码" sortable='custom' width='80px'></el-table-column>
                <el-table-column prop="crtime" label="异常时间" :formatter="formatterDateTime" sortable='custom' width="150"></el-table-column>
                <el-table-column prop="retime" label="重试时间" :formatter="formatterDateTime" sortable='custom' width="150"></el-table-column>
                <el-table-column prop="retrynum" label="重试次数" sortable='custom' width='80px'></el-table-column>
                <el-table-column label="操作" width='160px' align="center">
                    <template slot-scope="{row}">
                        <el-button title="查看堆栈" class="red" icon="el-icon-cpu" @click="handleViewStack(row.pestack)">查看堆栈</el-button>
                    </template>
                </el-table-column>
            </el-table>

<!--            <export-ctrl class="pull-left" @export="pageTable.handleExport($event, $refs.table)"/>-->
            <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr"
                           :total="pageTable.total"/>
        </Panel>

        <el-dialog close-on-press-escape append-to-body v-draggable title="异常堆栈内容" :visible.sync="stack.visible" width="60%"
                   :modal="false">
            <div v-if="stack.visible">
                <el-input type="textarea" :rows="20" placeholder="堆栈内容" v-model="stack.content"></el-input>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import BlockApi from "./Block";
    import {PageTable, UsualConfig} from 'cnetong-core-frontend';

    export default {
        name: "Block",
        props: {
            pageSize: {type: Number},
            tableHeight: {type: String, default: 'calc(100vh - 281px)'}
        },
        data() {
            return {
                UsualConfig,
                pageTable: new PageTable({
                    autoLoad: true,
                    doLoad: BlockApi.blocklist,
                    size: this.pageSize,
                    param: {
                        range_time: [new Date(new Date(new Date().setHours(0)).setMinutes(0)).setSeconds(0),
                            new Date(new Date(new Date().setHours(23)).setMinutes(59)).setSeconds(59)],
                        orderField: 're_time',
                        orderDirection: 'desc',
                    }
                }),
                multipleSelection: [],
                stack: {
                    visible: false,
                    content: ''
                },
            };
        },
        methods: {
            handleSorted({column, prop, order}) {
                if (!order) {
                    this.pageTable.param.orderDirection = 'desc';
                    this.pageTable.param.orderField = 're_time';
                    this.pageTable.handleLoad();
                    return;
                } else if (order === "ascending") {
                    this.pageTable.param.orderDirection = "asc";
                } else if (order === "descending") {
                    this.pageTable.param.orderDirection = "desc";
                }

                if (prop === "retime") {
                    this.pageTable.param.orderField = "re_time";
                } else if (prop === "pestack") {
                    this.pageTable.param.orderField = "pe_stack";
                } else if (prop === "pecode") {
                    this.pageTable.param.orderField = "pe_code";
                } else if (prop === "pedesc") {
                    this.pageTable.param.orderField = "pe_desc";
                } else if (prop === "tdname") {
                    this.pageTable.param.orderField = "td_name";
                } else if (prop === "msuid") {
                    this.pageTable.param.orderField = "ms_uid";
                } else if (prop === "crtime") {
                    this.pageTable.param.orderField = "cr_time";
                }

                this.pageTable.handleLoad();
            },
            handleViewStack(value) {
                this.stack.visible = true;
                this.stack.content = value;
            },
            // 删除全部
            async doAllDel() {
                try {
                    this.pageTable.isLoading = true;
                    await this.confirm();
                    await BlockApi.delAllBlock();
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            // 删除选定
            async doSeleDel() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                    return;
                }
                await this.confirm();
                try {
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await BlockApi.delBlock(array);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            // 中断选择的阻塞异常
            async interruptBlock() {
                if (this.multipleSelection.length === 0) {
                    this.$message.warning("请选择数据！");
                    return;
                }
                await this.confirm(null, '是否中断所选择的阻塞异常？');
                try {
                    this.pageTable.isLoading = true;
                    let array = this.multipleSelection.map(v => v.uuid);
                    await BlockApi.interruptBlock(array);
                    this.pageTable.handleLoad();
                } finally {
                    this.pageTable.isLoading = false;
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // dataTableLoad(params, resolve) {
            //     if (params.orderField === "retime") {
            //         params.orderField = "re_time";
            //     } else if (params.orderField === "pestack") {
            //         params.orderField = "pe_stack";
            //     } else if (params.orderField === "pecode") {
            //         params.orderField = "pe_code";
            //     } else if (params.orderField === "pedesc") {
            //         params.orderField = "pe_desc";
            //     } else if (params.orderField === "tdname") {
            //         params.orderField = "td_name";
            //     } else if (params.orderField === "msuid") {
            //         params.orderField = "ms_uid";
            //     } else if (params.orderField === "crtime") {
            //         params.orderField = "cr_time";
            //     }
            //     BlockApi.blocklist(params)
            //         .then(resolve)
            //         .then(respData => (this.table.data = respData.datas));
            // }
        }
    };
</script>

<style lang="scss" scoped>
    .checkbox-btn {
        padding: 0px 4px;
        font-size: 12px;
        vertical-align: middle;
        height: 22px;
        line-height: 22px;
        border-radius: 4px;
        color: #000;
        border-color: #32c5d2;
    }
</style>
